module.exports = __webpack_public_path__ + "img/Logo-IRS-Market-white.4633bfb2.png";